var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.message!==''&&!_vm.hidden)?_c('div',{class:_vm.classes,on:{"click":_vm.clicked}},[_c('span',{staticClass:"message",domProps:{"innerHTML":_vm._s(_vm.messageProcessed)}}),(_vm.hasClose)?_c('span',{staticClass:"close",on:{"click":_vm.close}},[_vm._v("X")]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }